import React from 'react';
import { Add } from '@mui/icons-material';
import { Button, Card, Chip, Box, Typography } from '@mui/material';

const CardContentWrapper = ({
  title,
  count,
  buttonText,
  onInvite,
  children
}) => (
  <Card
    elevation={2}
    sx={{
      p: 1.5,
      borderRadius: '8px',
      border: '1px solid #E3E3E3',
      width: '100%'
    }}>
    <Box
      sx={{
        display: 'flex',
        alignItems: 'start',
        justifyContent: 'space-between',
        mb: 1
      }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1
        }}>
        <Typography
          sx={{
            fontSize: 16,
            fontWeight: 500
          }}>
          {title}
        </Typography>

        <Chip
          label={count}
          size="small"
          sx={{
            height: 24,
            borderRadius: '6px',
            fontSize: 12,
            fontWeight: 500,
            backgroundColor: '#F2F2F2',
            color: '#424242'
          }}
        />
      </Box>
      
      <Button
        startIcon={<Add />}
        onClick={onInvite}
        variant="outlined"
        size='small'
        sx={{
          height: 36,
          px: 2,
          borderRadius: 1,
          borderColor: '#EFDCB5',
          bgcolor: '#F8F1E2',
          color: '#424242',
          fontWeight: 500,
          textTransform: 'uppercase',
          fontSize: '12px',
          gap: 0
        }}
        >{buttonText}
      </Button>
    </Box>
    
    {children}
  </Card>
);

export default CardContentWrapper;
